import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enTranslation from './en.json'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    // React already escapes values; no need for i18next to do it.
    escapeValue: false,
  },
})

export default i18n
